import classNames from 'classnames';
import { HTMLProps } from 'react';

import textBaseStyle from '../Text/text-base.module.css';
import style from './select.module.css';

export interface SelectOption {
  label: string;
  value: string;
}

interface SelectProps extends Omit<HTMLProps<HTMLSelectElement>, 'className'> {
  label: string;
  labelClassName?: string;
  options: SelectOption[];
  selectClassName?: string;
}

const Select = ({
  label,
  labelClassName,
  options,
  selectClassName,
  ...selectProps
}: SelectProps) => {
  const selectLabel = selectProps.required && !label.endsWith('*')
    ? `${label} *`
    : label;

  return (
    <label
      className={classNames(
        textBaseStyle.fontSize15,
        textBaseStyle.fontWeight700,
        labelClassName,
      )}
    >
      {selectLabel}

      <select
        className={classNames(style.select, selectClassName)}
        {...selectProps}
      >
        {options.map(option => {
          return (
            <option
              key={option.value}
              value={option.value}
            >
              {option.label}
            </option>
          );
        })}
      </select>
    </label>
  );
};

export default Select;
